function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var FactionTemplate = require('./faction.template');
var SaitoOverlay = require('./../../../../../lib/saito/ui/saito-overlay/saito-overlay');
var FactionOverlay = /*#__PURE__*/function () {
  function FactionOverlay(app, mod) {
    _classCallCheck(this, FactionOverlay);
    this.app = app;
    this.mod = mod;
    this.visible = false;
    this.overlay = new SaitoOverlay(app, mod);
    this.slideGeneration = 0;
    this.saintPetersFrom = null;
  }

  // Place markers on their previous squares, hold, then slide to the squares render() just drew.
  return _createClass(FactionOverlay, [{
    key: "slideTranslation",
    value: function slideTranslation(zone, fromNew, fromFull) {
      var translations = this.mod.game.state.translations;
      var toNew = translations['new'][zone];
      var toFull = translations['full'][zone];
      this.slideGeneration += 1;
      if (fromNew !== toNew) {
        var el = document.getElementById('new_testament_' + zone + '_tile');
        var fromBox = document.getElementById('protestant_translation_status_keytile' + fromNew);
        if (el && fromBox && el.parentElement) {
          this.slideChit(el, fromBox.getBoundingClientRect(), el.parentElement.getBoundingClientRect());
        }
      }
      if (fromFull !== toFull) {
        var _el = document.getElementById('bible_' + zone + '_tile');
        var _fromBox = document.getElementById('faction_sheet_keytile' + (fromFull + 1));
        if (_el && _fromBox && _el.parentElement) {
          this.slideChit(_el, _fromBox.getBoundingClientRect(), _el.parentElement.getBoundingClientRect());
        }
      }
    }
  }, {
    key: "slideSaintPeters",
    value: function slideSaintPeters(from) {
      var cathedral = this.mod.game.state.saint_peters_cathedral;
      this.slideGeneration += 1;
      if (from.state !== cathedral['state']) {
        var el = document.querySelector('.faction_sheet .saint_peters_tile');
        this.slideByStatusClass(el, from.state + 1, cathedral['state'] + 1);
      }
      if (from.vp !== cathedral['vp']) {
        var _el2 = document.querySelector('.faction_sheet .papacy_vp_tile');
        this.slideByStatusClass(_el2, 7 + from.vp, 7 + cathedral['vp']);
      }
    }
  }, {
    key: "slideByStatusClass",
    value: function slideByStatusClass(el, fromStatus, toStatus) {
      if (!el) {
        return;
      }
      var sheet = el.closest('.faction_sheet');
      if (!sheet) {
        return;
      }
      var probe = document.createElement('div');
      probe.className = 'faction_sheet_keytile papacy_construction_status' + fromStatus;
      probe.style.visibility = 'hidden';
      probe.style.pointerEvents = 'none';
      var toRect = el.getBoundingClientRect();
      sheet.appendChild(probe);
      var fromRect = probe.getBoundingClientRect();
      probe.remove();
      this.slideChit(el, fromRect, toRect);
    }
  }, {
    key: "slideChit",
    value: function slideChit(el, fromRect, toRect) {
      var _this = this;
      var dx = fromRect.left - toRect.left;
      var dy = fromRect.top - toRect.top;
      if (Math.abs(dx) < 0.5 && Math.abs(dy) < 0.5) {
        return;
      }
      var generation = this.slideGeneration;
      el.style.zIndex = '20';
      el.style.transition = 'none';
      el.style.transform = 'translate(' + dx + 'px, ' + dy + 'px)';
      void el.offsetWidth;
      setTimeout(function () {
        if (generation !== _this.slideGeneration) {
          return;
        }
        if (!el.isConnected) {
          return;
        }
        el.style.transition = 'transform 1s ease';
        el.style.transform = 'translate(0px, 0px)';
      }, 500);
    }
  }, {
    key: "hide",
    value: function hide() {
      this.overlay.hide();
    }
  }, {
    key: "updateNotice",
    value: function updateNotice() {
      var notice = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      try {
        document.querySelector('.faction_sheet_notice').innerHTML = notice;
      } catch (err) {}
    }
  }, {
    key: "render",
    value: function render() {
      var faction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var his_self = this.mod;
      this.visible = true;
      var f = this.mod.factions[faction];
      this.overlay.show(FactionTemplate(f));
      this.app.browser.addElementToSelector("<div class=\"faction_sheet_notice ".concat(f.key, "\" id=\"faction_sheet_notice\"></div>"), '.faction_sheet');
      var controlled_keys = 0;
      var keyboxen = '';
      var war_winner_vp = 0;
      for (var key in his_self.game.spaces) {
        if (his_self.game.spaces[key].type === 'key') {
          var owner = his_self.game.spaces[key].political;
          if (owner == '') {
            owner = his_self.game.spaces[key].home;
          }
          owner = his_self.returnControllingPower(owner);
          if (owner == his_self.factions[faction].key) {
            controlled_keys++;
          }
        }
      }

      // ENGLAND
      if (his_self.factions[faction].key === 'england') {
        war_winner_vp = his_self.game.state.england_war_winner_vp;
        var total_keys = 9;
        var _controlled_keys = his_self.returnNumberOfKeysControlledByFaction('england');
        var remaining_keys = total_keys - _controlled_keys;
        for (var i = 0; i < 7; i++) {
          var hcss = '';
          if (i == his_self.game.state.henry_viii_marital_status) {
            hcss = 'active ';
          }
          if (i > his_self.game.state.henry_viii_marital_status) {
            hcss = 'show_wife';
          }
          keyboxen += "<div class=\"".concat(hcss, " faction_sheet_keytile henry_viii_marital_status henry_viii_marital_status").concat(i + 1, "\" id=\"henry_viii_marital_status").concat(i + 1, "\"></div>");
        }
        for (var _i = 1; _i <= 9; _i++) {
          if (_i > _controlled_keys) {
            keyboxen += "<div class=\"faction_sheet_keytile faction_sheet_".concat(his_self.factions[faction].key, "_keytile").concat(_i, " england_keytile\" id=\"faction_sheet_keytile").concat(_i, "\"></div>");
          }
        }
        if (his_self.game.state.leaders.henry_viii == 1) {}
        if (his_self.game.state.leaders.edward_vi == 1) {
          this.app.browser.addElementToSelector(his_self.returnCardImage('019'), '.faction_sheet_ruler');
        }
        if (his_self.game.state.leaders.mary_i == 1) {
          this.app.browser.addElementToSelector(his_self.returnCardImage('021'), '.faction_sheet_ruler');
        }
        if (his_self.game.state.leaders.elizabeth_i == 1) {
          this.app.browser.addElementToSelector(his_self.returnCardImage('023'), '.faction_sheet_ruler');
        }
      }

      // FRANCE
      if (his_self.factions[faction].key === 'france') {
        war_winner_vp = his_self.game.state.france_war_winner_vp;
        var _total_keys = 11;
        var _remaining_keys = _total_keys - controlled_keys;
        for (var _i2 = 0; _i2 < 7; _i2++) {
          var c = '';
          if (_i2 == his_self.game.state.french_chateaux_vp) {
            c = 'faction_sheet_france_vp_keytile';
          }
          keyboxen += "<div class=\"faction_sheet_keytile ".concat(c, " france_chateaux_status").concat(_i2 + 1, "\" id=\"france_chateaux_status_keytile").concat(_i2 + 1, "\"></div>");
        }
        for (var _i3 = 1; _i3 <= 11; _i3++) {
          if (_i3 > 11 - _remaining_keys) {
            keyboxen += "<div class=\"faction_sheet_keytile faction_sheet_france_keytile faction_sheet_".concat(his_self.factions[faction].key, "_keytile").concat(_i3, "\" id=\"faction_sheet_keytile").concat(_i3, "\"></div>");
          }
        }
        if (his_self.game.state.leaders.henry_ii == 1) {
          this.app.browser.addElementToSelector(his_self.returnCardImage('020'), '.faction_sheet_ruler');
        }
      }
      // OTTOMAN
      if (his_self.factions[faction].key === 'ottoman') {
        war_winner_vp = his_self.game.state.ottoman_war_winner_vp;
        var _total_keys2 = 11;
        var _remaining_keys2 = _total_keys2 - controlled_keys;
        for (var _i4 = 0; _i4 <= 10; _i4++) {
          var xcs = '';
          if (_i4 == his_self.game.state.events.ottoman_piracy_vp) {
            xcs = 'ottoman_piracy_keytile';
          }
          keyboxen += "<div class=\"faction_sheet_keytile ".concat(xcs, " ottoman_piracy_status").concat(_i4, "\" id=\"ottoman_piracy_status_keytile").concat(_i4, "\"></div>");
        }
        for (var _i5 = 1; _i5 <= 11; _i5++) {
          if (_i5 > 11 - _remaining_keys2) {
            keyboxen += "<div class=\"faction_sheet_keytile ottoman_keytile faction_sheet_".concat(his_self.factions[faction].key, "_keytile").concat(_i5, "\" id=\"faction_sheet_keytile").concat(_i5, "\"></div>");
          }
        }
      }
      // PAPACY
      if (his_self.factions[faction].key === 'papacy') {
        ////////////////////
        // excommunicated //
        ////////////////////
        var exhtml = '';
        if (his_self.game.state.excommunicated_factions['england'] == 1) {
          exhtml += "<div class=\"excommunicated england\"></div>";
        }
        if (his_self.game.state.excommunicated_factions['france'] == 1) {
          exhtml += "<div class=\"excommunicated france\"></div>";
        }
        if (his_self.game.state.excommunicated_factions['hapsburg'] == 1) {
          exhtml += "<div class=\"excommunicated hapsburg\"></div>";
        }
        for (var _i6 = 0; _i6 < his_self.game.state.excommunicated.length; _i6++) {
          var obj = his_self.game.state.excommunicated[_i6];
          if (obj.reformer) {
            if (obj.reformer.type == 'luther-reformer') {
              exhtml += "<div class=\"excommunicated luther-reformer\"></div>";
            }
            if (obj.reformer.type == 'zwingli-reformer') {
              exhtml += "<div class=\"excommunicated zwingli-reformer\"></div>";
            }
            if (obj.reformer.type == 'calvin-reformer') {
              exhtml += "<div class=\"excommunicated calvin-reformer\"></div>";
            }
            if (obj.reformer.type == 'cramner-reformer') {
              exhtml += "<div class=\"excommunicated cramner-reformer\"></div>";
            }
          }
        }
        if (exhtml != '') {
          this.app.browser.addElementToSelector(exhtml, '.faction_sheet');
        }
        war_winner_vp = his_self.game.state.papacy_war_winner_vp;
        var _total_keys3 = 7;
        controlled_keys = his_self.returnNumberOfKeysControlledByFaction('papacy');
        var _remaining_keys3 = _total_keys3 - controlled_keys;
        console.log(_remaining_keys3 + ' = ' + _total_keys3 + ' - ' + controlled_keys);
        for (var _i7 = 0; _i7 < 12; _i7++) {
          if (his_self.game.state.saint_peters_cathedral['state'] == _i7) {
            keyboxen += "<div class=\"faction_sheet_keytile papacy_construction_status".concat(_i7 + 1, " saint_peters_tile\" id=\"papacy_construction_status_keytile").concat(_i7 + 1, "\"></div>");
          }
          if (his_self.game.state.saint_peters_cathedral['vp'] == _i7) {
            keyboxen += "<div class=\"faction_sheet_keytile papacy_construction_status".concat(7 + _i7, " papacy_vp_tile\" id=\"papacy_construction_status_keytile").concat(7 + _i7, "\"></div>");
          }
        }
        for (var _i8 = 1; _i8 <= 7; _i8++) {
          if (_i8 > controlled_keys) {
            keyboxen += "<div class=\"faction_sheet_keytile faction_sheet_".concat(his_self.factions[faction].key, "_keytile").concat(_i8, " papacy_keytile\" id=\"faction_sheet_keytile").concat(_i8, "\"></div>");
          }
        }
        if (his_self.game.state.leaders.clement_vii == 1) {
          this.app.browser.addElementToSelector(his_self.returnCardImage('010'), '.faction_sheet_ruler');
        }
        if (his_self.game.state.leaders.paul_iii == 1) {
          this.app.browser.addElementToSelector(his_self.returnCardImage('014'), '.faction_sheet_ruler');
        }
        if (his_self.game.state.leaders.julius_iii == 1) {
          this.app.browser.addElementToSelector(his_self.returnCardImage('022'), '.faction_sheet_ruler');
        }
      }

      // PROTESTANTS
      if (his_self.factions[faction].key === 'protestant') {
        war_winner_vp = his_self.game.state.protestant_war_winner_vp;
        for (var _i9 = 0; _i9 <= 6; _i9++) {
          var box_inserts = '';
          if (his_self.game.state.translations['new']['german'] == _i9) {
            box_inserts += "<div class=\"new_testament_german_tile\" id=\"new_testament_german_tile\"></div>";
          }
          if (his_self.game.state.translations['new']['french'] == _i9) {
            box_inserts += "<div class=\"new_testament_french_tile\" id=\"new_testament_french_tile\"></div>";
          }
          if (his_self.game.state.translations['new']['english'] == _i9) {
            box_inserts += "<div class=\"new_testament_english_tile\" id=\"new_testament_english_tile\"></div>";
          }
          keyboxen += "<div class=\"faction_sheet_keytile protestant_translation_status".concat(_i9, "\" id=\"protestant_translation_status_keytile").concat(_i9, "\">").concat(box_inserts, "</div>");
        }
        for (var _i0 = 1; _i0 <= 12; _i0++) {
          var _box_inserts = '';
          if (his_self.game.state.translations['full']['german'] == _i0 - 1) {
            _box_inserts += "<div class=\"bible_german_tile\" id=\"bible_german_tile\"></div>";
          }
          if (his_self.game.state.translations['full']['french'] == _i0 - 1) {
            _box_inserts += "<div class=\"bible_french_tile\" id=\"bible_french_tile\"></div>";
          }
          if (his_self.game.state.translations['full']['english'] == _i0 - 1) {
            _box_inserts += "<div class=\"bible_english_tile\" id=\"bible_english_tile\"></div>";
          }
          keyboxen += "<div class=\"faction_sheet_keytile faction_sheet_".concat(his_self.factions[faction].key, "_keytile").concat(_i0, "\" id=\"faction_sheet_keytile").concat(_i0, "\">").concat(_box_inserts, "</div>");
        }
        if (his_self.game.state.leaders.calvin == 1) {
          this.app.browser.addElementToSelector(his_self.returnCardImage('016'), '.faction_sheet_ruler');
        }
      }

      // HAPSBURG
      if (his_self.factions[faction].key === 'hapsburg') {
        war_winner_vp = his_self.game.state.hapsburg_war_winner_vp;
        var _total_keys4 = 14;
        var _remaining_keys4 = _total_keys4 - controlled_keys;
        for (var _i1 = 1; _i1 <= 14; _i1++) {
          if (_i1 > 14 - _remaining_keys4) {
            keyboxen += "<div class=\"faction_sheet_keytile faction_sheet_hapsburg_keytile faction_sheet_".concat(his_self.factions[faction].key, "_keytile").concat(_i1, "\" id=\"faction_sheet_keytile").concat(_i1, "\"></div>");
          }
        }
      }
      this.app.browser.addElementToSelector(keyboxen, '.faction_sheet');

      //
      // captured leaders
      //
      var p = his_self.returnPlayerCommandingFaction(faction);
      if (p > 0) {
        for (var z = 0; z < his_self.game.state.players_info[p - 1].captured.length; z++) {
          var _c = his_self.game.state.players_info[p - 1].captured[z];
          if (_c.capturing_faction == faction) {
            if (_c.army_leader) {
              this.app.browser.addElementToSelector("<div class=\"army_tile\" style=\"background-image: url(/his/img/tiles/army/".concat(_c.img, ")\"></div>"), '.faction_sheet_vp');
            }
            if (_c.navy_leader) {
              this.app.browser.addElementToSelector("<div class=\"army_tile\" style=\"background-image: url(/his/img/tiles/navy/".concat(_c.img, ")\"></div>"), '.faction_sheet_vp');
            }
          }
        }
      }

      //
      // master of italy
      //
      var master_of_italy_vp = his_self.game.state.master_of_italy[faction];
      while (master_of_italy_vp >= 2) {
        this.app.browser.addElementToSelector('<div class="master_of_italy_vp vp2"></div>', '.faction_sheet_vp');
        master_of_italy_vp -= 2;
      }
      while (master_of_italy_vp >= 1) {
        this.app.browser.addElementToSelector('<div class="master_of_italy_vp vp1"></div>', '.faction_sheet_vp');
        master_of_italy_vp -= 1;
      }

      //
      // War Winner VPs
      //
      while (war_winner_vp >= 2) {
        this.app.browser.addElementToSelector('<div class="war_winner_vp vp2"></div>', '.faction_sheet_vp');
        war_winner_vp -= 2;
      }
      while (war_winner_vp >= 1) {
        this.app.browser.addElementToSelector('<div class="war_winner_vp vp1"></div>', '.faction_sheet_vp');
        war_winner_vp -= 1;
      }

      //
      // New World Discoveries
      //
      for (var _key in his_self.game.state.newworld) {
        if (his_self.game.state.newworld[_key].type == 'discovery' && his_self.game.state.newworld[_key].claimed == 1 && his_self.game.state.newworld[_key].faction == faction) {
          this.app.browser.addElementToSelector("<div class=\"new_world_vp ".concat(_key, "\"></div>"), '.faction_sheet_vp');
        }
      }

      //
      // Edward and Elizabeth
      //
      if (his_self.factions[faction].key === 'england') {
        if (his_self.game.state.henry_viii_healthy_edward == 1 || his_self.game.state.henry_viii_sickly_edward == 1) {
          var html = "<div class=\"debaters-tile\" data-key=\"\" data-id=\"\" style=\"background-image: url(/his/img/tiles/vp/Edward.svg);\"></div>";
          this.app.browser.addElementToSelector(html, '.faction_sheet_vp');
        } else {
          if (his_self.game.state.henry_viii_add_elizabeth > 0) {
            var _html = "<div class=\"debaters-tile\" data-key=\"\" data-id=\"\" style=\"background-image: url(/his/img/tiles/vp/Elizabeth.svg);\"></div>";
            this.app.browser.addElementToSelector(_html, '.faction_sheet_vp');
          }
        }
      }

      //
      // Disgraced and Burned Debaters
      //
      if (his_self.factions[faction].key === 'protestant') {
        for (var _i10 = 0; _i10 < his_self.game.state.burned.length; _i10++) {
          var dn = his_self.game.state.burned[_i10];
          var dd = his_self.debaters[dn];
          if (dd.faction === 'papacy') {
            var vp_bonus = dd.power;
            var _html2 = "<div class=\"debaters-tile\" data-key=\"".concat(dd.key, "\" data-id=\"").concat(dd.key, "\" style=\"background-image: url(/his/img/tiles/debaters/").concat(dd.img, ");\"></div>");
            this.app.browser.addElementToSelector(_html2, '.faction_sheet_vp');
          }
        }
      }
      if (his_self.factions[faction].key === 'papacy') {
        for (var _i11 = 0; _i11 < his_self.game.state.burned.length; _i11++) {
          var _dn = his_self.game.state.burned[_i11];
          var _dd = his_self.debaters[_dn];
          if (_dd.faction === 'protestant') {
            var _vp_bonus = _dd.power;
            var _html3 = "<div class=\"debaters-tile\" data-key=\"".concat(_dd.key, "\" data-id=\"").concat(_dd.key, "\" style=\"background-image: url(/his/img/tiles/debaters/").concat(_dd.img, ");\"></div>");
            this.app.browser.addElementToSelector(_html3, '.faction_sheet_vp');
          }
        }
      }

      //
      // Bible Translations
      //
      if (his_self.factions[faction].key === 'protestant') {
        if (his_self.game.state.translations['full']['german'] >= 10) {
          var _html4 = "<div class=\"debaters-tile\" data-key=\"\" data-id=\"\" style=\"background-image: url(/his/img/factions/BibleGerman.svg\"></div>";
          this.app.browser.addElementToSelector(_html4, '.faction_sheet_vp');
        }
        if (his_self.game.state.translations['full']['english'] >= 10) {
          var _html5 = "<div class=\"debaters-tile\" data-key=\"\" data-id=\"\" style=\"background-image: url(/his/img/factions/BibleEnglish.svg\"></div>";
          this.app.browser.addElementToSelector(_html5, '.faction_sheet_vp');
        }
        if (his_self.game.state.translations['full']['french'] >= 10) {
          var _html6 = "<div class=\"debaters-tile\" data-key=\"\" data-id=\"\" style=\"background-image: url(/his/img/factions/BibleFrench.svg\"></div>";
          this.app.browser.addElementToSelector(_html6, '.faction_sheet_vp');
        }
      }
      this.attachEvents();
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {}
  }]);
}();
module.exports = FactionOverlay;